module.exports = __webpack_public_path__ + "static/media/group-people-community.3a739ca0.svg";